(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nbd-add-on"] && !Shopify.designMode) return;
  try {
    // Keyed by window.Shopify.theme.schema_name, so the theme's cart refreshes after a change.
const NBD_ADD_ON_REFRESH_EVENTS = {
  Symmetry: 'on:cart:change',
};

class NBDAddOn extends HTMLElement {
  constructor() {
    super();

    this.cartAddUrl = window.Shopify.routes.root + 'cart/add.js';
    this.cartUpdateUrl = window.Shopify.routes.root + 'cart/update.js';
    this.min = 0;
    this.limit = parseInt(this.getAttribute('data-limit'));
    this.variantId = this.getAttribute('data-id');
    this.quantityInput = this.querySelector('input[data-quantity]');
    this.decreaseButton = this.querySelector('button[data-decrease]');
    this.increaseButton = this.querySelector('button[data-increase]');

    this.decreaseButton.addEventListener('click', () => this.quantity--);
    this.increaseButton.addEventListener('click', () => this.quantity++);
  }

  get quantity() {
    return this.quantityInput.value;
  }

  set quantity(value) {
    if (value < this.min || value > this.limit) return;
    this.enableLoading();
    this.updateCart(value)
    .then(cart => {
      this.quantityInput.value = this.getCartQuantity(cart);
      const refreshEvent = NBD_ADD_ON_REFRESH_EVENTS[window.Shopify?.theme?.schema_name];
      if (refreshEvent) {
        document.dispatchEvent(new CustomEvent(refreshEvent, { bubbles: true, cancelable: false }));
      }
    })
    .catch(err => console.error(err))
    .finally(() => this.disableLoading());
  }

  enableLoading() {
    this.classList.add('loading');
    this.decreaseButton.disabled = true;
    this.increaseButton.disabled = true;
  }

  disableLoading() {
    this.classList.remove('loading');
    this.decreaseButton.disabled = this.quantity <= this.min;
    this.increaseButton.disabled = this.quantity >= this.limit;
  }

  async updateCart(quantity) {
    return (this.quantity > 0)
      ? await this.postJson(this.cartUpdateUrl, { updates: { [this.variantId]: quantity } })
      : await this.postJson(this.cartAddUrl, { items: [{ id: this.variantId, quantity }] });
  }

  async postJson(url, data = {}) {
    const res = await fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return res.json();
  }

  getCartQuantity(cart) {
    return cart?.items?.find(i => i.variant_id == this.variantId)?.quantity || 0;
  }
}

if (!customElements.get('nbd-add-on')) {
  customElements.define('nbd-add-on', NBDAddOn);
}
  } catch(e) { console.error(e); }
})();

})();
